document.addEventListener('DOMContentLoaded', function() {

  // Use event delegation for better reliability
  document.addEventListener('click', function(e) {
    // Handle shape/type button clicks
    const shapeButton = e.target.closest('.new-bundle__picker__bundle__content__shapes__items__shape');
    if (shapeButton) {
      e.preventDefault();
      const bundleContent = shapeButton.closest('.new-bundle__picker__bundle__content');
      const shape = shapeButton.getAttribute('data-shape');

      // Update bundle state
      bundleContent.setAttribute('data-selected-shape', shape);

      // Update active button
      const allShapeButtons = bundleContent.querySelectorAll('.new-bundle__picker__bundle__content__shapes__items__shape');
      allShapeButtons.forEach(btn => {
        btn.classList.remove('new-bundle__picker__bundle__content__shapes__items__shape--active');
        btn.setAttribute('aria-pressed', 'false');
      });
      shapeButton.classList.add('new-bundle__picker__bundle__content__shapes__items__shape--active');
      shapeButton.setAttribute('aria-pressed', 'true');

      // Update main product image
      updateMainProductImage(bundleContent);
    }
  });

  // Handle color dropdown changes
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('new-bundle__picker__bundle__content__colors__dropdown')) {
      const colorDropdown = e.target;
      const bundleContent = colorDropdown.closest('.new-bundle__picker__bundle__content');
      const color = colorDropdown.value;

      // Update bundle state
      bundleContent.setAttribute('data-selected-color', color);

      // Update main product image
      updateMainProductImage(bundleContent);
    }
  });

  function updateMainProductImage(bundleContent) {
    const currentColor = bundleContent.getAttribute('data-selected-color');
    const currentShape = bundleContent.getAttribute('data-selected-shape');

    console.log('Updating image for:', { color: currentColor, shape: currentShape });

    // Get variants data
    let variants = [];
    try {
      const variantsAttr = bundleContent.getAttribute('data-variants');
      if (variantsAttr) {
        // Decode HTML entities
        const textarea = document.createElement('textarea');
        textarea.innerHTML = variantsAttr;
        variants = JSON.parse(textarea.value);
      }
    } catch (err) {
      console.error('Error parsing variants:', err);
      return;
    }

    // Find matching variant
    const targetVariant = variants.find(v => v.color === currentColor && v.shape === currentShape);
    console.log('Found variant:', targetVariant);

    if (targetVariant && targetVariant.image) {
      // Update variant ID
      bundleContent.setAttribute('data-selected-variant-id', targetVariant.id);

      // Try to find and update the main product slider
      const productSlider = document.querySelector('product-slider.product-images');

      if (productSlider && typeof Flickity !== 'undefined') {
        const flkty = Flickity.data(productSlider);

        if (flkty) {
          // Find the slide with matching image
          const slides = productSlider.querySelectorAll('.product-images__slide');
          let targetSlideIndex = -1;

          // Extract image filename for comparison
          const targetImageName = targetVariant.image.split('/').pop().split('?')[0];

          slides.forEach((slide, index) => {
            const img = slide.querySelector('img');
            if (img) {
              const slideImageName = img.src.split('/').pop().split('?')[0];
              if (slideImageName === targetImageName || img.src.includes(targetImageName)) {
                targetSlideIndex = index;
              }
            }
          });

          console.log('Target slide index:', targetSlideIndex);

          if (targetSlideIndex >= 0) {
            flkty.select(targetSlideIndex);
          }
        }
      }

      // Also try to trigger the theme's variant selector
      triggerVariantChange(targetVariant, currentColor, currentShape);
    }
  }

  function triggerVariantChange(variant, color, shape) {
    // Try to find and click the variant selector inputs
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    // Find color input
    const colorInputs = variantSelects.querySelectorAll('input[type="radio"]');
    colorInputs.forEach(input => {
      if (input.value === color && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Small delay then find shape input
    setTimeout(() => {
      const shapeInputs = variantSelects.querySelectorAll('input[type="radio"]');
      shapeInputs.forEach(input => {
        if (input.value === shape && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }, 100);
  }

  // Re-initialize when bundle radio changes (to handle hidden/shown bundles)
  document.addEventListener('change', function(e) {
    if (e.target.name === 'bundle-choice') {
      // Bundle selection changed - the new bundle items are now visible
      console.log('Bundle changed to:', e.target.value);
    }
  });

});
